/** Lido wstETH — 1e18-scaled stETH-per-wstETH ratio. */
export const LidoWstEthAbi = [
  {
    name: 'stEthPerToken',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
